import Vue from 'vue'
import Vuex from 'vuex'
import BackendService from '@/services/requests/backendService'
import FrontendConfigService from '@/services/configs/frontendConfigService'
Vue.use(Vuex)

const adminAgendamentoStore = new Vuex.Store({
  state: {
    loading: false,

    agendas: [],
    loadingAgendas:false,

    notifications:[]
  },
  mutations: {
    setLoading(state, value) { state.loading = value },
    
    setAgendas(state, value) { state.agendas = value },
    setLoadingAgendas(state, value) { state.loadingAgendas = value },
    
    setNotifications(state, value){ state.notifications = value }
  },
  getters:{ 
    getIsLoading(state){
      return state.loading || state.loadingAgendas
    },
    getNotifications(state){
			return state.notifications
		},
  },
  actions: {
    tryError: async(context, error)=>{
			let err = FrontendConfigService.tryNotificationErrors(error)
			context.commit('setNotifications', [{'tag':err.tag, 'message': err.message}])
		},
    get_agendas: async (context, params)=>{
      const req = new BackendService()
      context.commit('setLoadingAgendas', true)
      return await req.get_agendamentos(params)
      .then( response => { 
        console.log(response.data); 
        context.commit('setAgendas', response.data)
      }).catch( error => { 
        console.error(error.response); 
        context.commit('setAgendas', [])
        context.dispatch('tryError', error) 
      }).finally( () => { 
        context.commit('setLoadingAgendas', false) 
      })
    },
    patch_agenda: async (context, agenda)=>{
      console.log(agenda)
      const req = new BackendService()
      //context.commit('setLoading', true)
      return await req.patch_agendamento(agenda.id, agenda)
      /*
      .then( response => {
        context.commit('setNotifications', [{'tag':'success', 'message': `Agendamento ${response.data.solicitante} - ${response.data.get_formatted_data} das ${ response.data.start} às ${response.data.end} atualizado com sucesso!`}])
        context.dispatch('get_agendas','')
      }).catch( error => { 
        console.error(error.response);
        context.dispatch('tryError', error)
      }).finally( () => { 
        context.commit('setLoading', false) 
      })*/
    },
    aprovar_reserva: async (context, agenda)=>{
      
      const req = new BackendService()
      context.commit('setLoading', true)
      return await req.aprova_reserva(agenda.id, agenda)
      .then( response => {
        context.commit('setNotifications', [{'tag':'success', 'message': `Status de reserva #${response.data.id} alterado com sucesso para ${response.data.status_agenda}!`}])
        context.dispatch('get_agendas','')
      }).catch( error => { 
        console.error(error.response);
        context.dispatch('tryError', error)
      }).finally( () => { 
        context.commit('setLoading', false) 
      })
    },
  }
})

export default adminAgendamentoStore
